module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isPageReady) ? _c('v-container', {
    staticClass: "genre",
    class: {
      onMobile: _vm.onMobile
    },
    attrs: {
      "pa-0": ""
    }
  }, [_c('div', {
    staticClass: "dflex justify-space-between align-center"
  }, [_c('div', {}, [(_vm.show_selector_view) ? _c('h3', {
    staticClass: "_title"
  }, [_vm._v("Genre filters")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "_subtitle d-block justify-space-between",
    class: {
      'dflex': !_vm.onMobile
    }
  }, [_c('div', [(!_vm.show_selector_view) ? _c('v-btn', {
    staticClass: "back-to-genre",
    attrs: {
      "fab": "",
      "round": ""
    },
    nativeOn: {
      "click": function($event) {
        (_vm.show_selector_view = true)
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.show_selector_view) ? _c('span', {
    staticClass: "back-label"
  }, [_vm._v("Back to Genres")]) : _vm._e()], 1), _vm._v(" "), (_vm.show_selector_view) ? _c('p', [_vm._v("\n              Genres you select will appear on Discover\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.onMobile) ? _c('p', [_vm._v("\n              Tap and hold to select subgenres\n\t\t\t\t\t\t")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "dflex align-top align-center"
  }, [(_vm.show_selector_view) ? _c('div', {
    staticClass: "input-genre-group"
  }, [_c('input', {
    staticClass: "input-genre",
    attrs: {
      "id": "filter-select",
      "type": "text",
      "placeholder": "Search genres"
    },
    on: {
      "keyup": function($event) {
        _vm.filterRecords()
      },
      "focus": function($event) {
        (_vm.inputDropdown = true)
      }
    }
  }), _vm._v(" "), (_vm.inputDropdown) ? _c('div', [_c('div', {
    staticClass: "genre-dropdown-overlay",
    on: {
      "click": function($event) {
        (_vm.inputDropdown = false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "genre-dropdown",
    attrs: {
      "id": "genre-dropdown"
    }
  }, [_c('div', {
    staticClass: "genre-container"
  }, _vm._l((_vm.genres), function(parent) {
    return _c('div', {
      key: parent.id
    }, [_c('div', _vm._b({
      staticClass: "genre-block"
    }, 'div', _vm.child in parent.children, false), [(_vm.subGenresName.includes(_vm.child.name.toLowerCase())) ? _c('div', [_c('input', {
      staticClass: "check-box",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.selectedSubgenresIds.includes(_vm.child.id)
      },
      on: {
        "click": function($event) {
          _vm.selectSubGenre(_vm.child, parent)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "text",
      attrs: {
        "for": "check"
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.child.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "subtitle"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(parent.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")])])]) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticClass: "btn-dropdown"
  }, [_c('v-btn', {
    staticClass: "btn-purple",
    on: {
      "click": function($event) {
        (_vm.inputDropdown = false)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tSelect\n\t\t\t\t\t\t\t\t")])], 1)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.onMobile && _vm.show_selector_view) ? _c('v-btn', {
    staticClass: "update-btn",
    attrs: {
      "round": "",
      "dark": "",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.saveGenreFilters()
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tSave\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (!_vm.show_selector_view) ? _c('v-btn', {
    staticClass: "update-btn",
    attrs: {
      "round": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        (_vm.show_selector_view = true)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tSave\n\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), (_vm.onMobile) ? _c('img', {
    attrs: {
      "src": require("../../static/images/ic_close_dark.svg"),
      "width": "18"
    },
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-lg": "",
      "px-0": "",
      "pt-0": ""
    }
  }, [(_vm.show_selector_view) ? _c('v-layout', {
    staticClass: "pgs_area",
    attrs: {
      "row": "",
      "wrap": "",
      "mt-4": ""
    }
  }, _vm._l((_vm.genres), function(parent, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "pgs-wrapper",
      attrs: {
        "xs12": "",
        "sm2": ""
      }
    }, [_c('div', {
      key: parent.id,
      staticClass: "pgs"
    }, [_c('div', {
      class: [_vm.selectedMainGenresIds.includes(parent.id) ? 'pgs-inner-wrapper selected' : 'pgs-inner-wrapper'],
      on: {
        "click": function($event) {
          _vm.selectParentGenre(parent)
        }
      }
    }, [_c('div', {
      staticClass: "pgs-inner"
    }, [_c('div', {
      staticClass: "pgs__title"
    }, [_c('label', [_vm._v(_vm._s(parent.name))])]), _vm._v(" "), _c('div', {
      staticClass: "dflex align-center justify-space-between"
    }, [_c('div', {
      staticClass: "pgs__description"
    }, [_c('span', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.selectParent(parent, index)
        }
      }
    }, [_vm._v(_vm._s(_vm.getSelectedChildrenCount(parent)) + " Subgenres")])]), _vm._v(" "), _c('div', {
      staticClass: "highlight-circle"
    })]), _vm._v(" "), _c('div', {
      staticClass: "pgs__content"
    }, [_c('div', {
      staticClass: "upload-info"
    }, [_c('label', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(parent.users_size)))]), _vm._v(" "), _c('span', [_vm._v("Albums")])]), _vm._v(" "), (parent.value) ? _c('div', {
      staticClass: "pgs__badge check-o"
    }) : _c('div', {
      staticClass: "pgs__badge check"
    })])]), _vm._v(" "), (_vm.onMobile && parent.value) ? _c('div', {
      staticClass: "_selected"
    }, [_vm._v("\n                Selected\n              ")]) : _vm._e()])])])
  })) : _vm._e(), _vm._v(" "), (_vm.onMobile) ? _c('div', {
    staticClass: "_save-section"
  }, [_c('v-btn', {
    staticClass: "update-btn",
    attrs: {
      "round": "",
      "dark": "",
      "color": "black",
      "loading": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.saveGenreFilters()
      }
    }
  }, [_vm._v("\n          Save\n        ")])], 1) : _vm._e()], 1), _vm._v(" "), (!_vm.show_selector_view) ? _c('div', {
    staticClass: "genre-container"
  }, [_c('div', {
    staticClass: "pgs-wrapperx"
  }, [_c('div', {
    key: _vm.parent.id,
    staticClass: "pgx"
  }, [_c('div', {
    staticClass: "pgs-inner-wrapper-x"
  }, [_c('div', {
    staticClass: "pgs-inner-x"
  }, [_c('div', {
    staticClass: "pgs__title"
  }, [_vm._v(_vm._s(_vm.parent.name))]), _vm._v(" "), _c('div', {
    staticClass: "pgs__description"
  }, [_vm._v("\n                " + _vm._s(_vm.getSelectedChildrenCount(_vm.parent)) + " of " + _vm._s(_vm.groupChildrenByRegion(_vm.parent)[("" + (_vm.parent.name))].length) + " Subgenres selected\n              ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "genre__content"
  }, [_c('v-layout', {
    key: _vm.parent.id,
    attrs: {
      "row": "",
      "wrap": "",
      "ma-0": ""
    }
  }, [(Object.keys(_vm.groupChildrenByRegion(_vm.parent)).length == 1) ? _vm._l((_vm.parent.children), function(child) {
    return _c('v-flex', {
      key: child.id,
      staticClass: "pgs-wrapper sub-genre-filter",
      attrs: {
        "xs12": "",
        "sm2": ""
      }
    }, [_c('div', {
      staticClass: "settings child-genre mx-auto",
      class: [!_vm.selectedSubgenresIds.includes(child.id) ? 'selected' : '']
    }, [_c('input', {
      staticClass: "d-none",
      attrs: {
        "id": child.id,
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.selectedSubgenresIds.includes(child.id)
      },
      on: {
        "click": function($event) {
          _vm.checkChildGenre(_vm.parent, child)
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": child.id
      }
    }, [_vm._v(_vm._s(child.name))])])])
  }) : [_vm._l((_vm.groupChildrenByRegion(_vm.parent)), function(values, key) {
    return [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('h5', [_vm._v(_vm._s(key))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm12": ""
      }
    }, [_c('p', {
      staticClass: "regular-checkbox settings parent-genre"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.region[((_vm.parent.id) + "-" + key)]),
        expression: "region[`${parent.id}-${key}`]"
      }],
      attrs: {
        "id": ((_vm.parent.id) + "-" + key),
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.region[((_vm.parent.id) + "-" + key)]) ? _vm._i(_vm.region[((_vm.parent.id) + "-" + key)], null) > -1 : (_vm.region[((_vm.parent.id) + "-" + key)])
      },
      on: {
        "click": function($event) {
          _vm.checkRegionGenre(_vm.parent, key)
        },
        "change": function($event) {
          var $$a = _vm.region[((_vm.parent.id) + "-" + key)],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.region[((_vm.parent.id) + "-" + key)] = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.region[((_vm.parent.id) + "-" + key)] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.region, ((_vm.parent.id) + "-" + key), $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ((_vm.parent.id) + "-" + key)
      }
    }, [_vm._v("Select All")])])]), _vm._v(" "), _vm._l((values), function(child) {
      return _c('v-flex', {
        key: child.id,
        attrs: {
          "xs12": "",
          "sm3": ""
        }
      }, [_c('p', {
        staticClass: "regular-checkbox settings child-genre"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (child.value),
          expression: "child.value"
        }],
        attrs: {
          "id": child.id,
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(child.value) ? _vm._i(child.value, null) > -1 : (child.value)
        },
        on: {
          "click": function($event) {
            _vm.checkChildGenre(_vm.parent, child)
          },
          "change": function($event) {
            var $$a = child.value,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (child.value = $$a.concat([$$v]))
              } else {
                $$i > -1 && (child.value = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.$set(child, "value", $$c)
            }
          }
        }
      }), _vm._v(" "), _c('label', {
        attrs: {
          "for": child.id
        }
      }, [_vm._v(_vm._s(child.name))])])])
    })]
  })]], 2)], 1)]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b76752ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/genre_dialog.vue
// module id = 1839
// module chunks = 180